'use client';

import { useState } from 'react';
import { Box, Card, HyperLink, Image } from '@doist/marketist';
import { FeatureRadioTile } from 'components/feature-radio-tile/feature-radio-tile';
import { FeatureRadioTileGroup } from 'components/feature-radio-tile/feature-radio-tile-group';
import { type TemplateListProps } from './template-list-container';
import css from './templates-section.module.css';
export function TemplateListMobile({
  categories
}: TemplateListProps) {
  const [categoryId, setCategoryId] = useState<string>(categories[0].id);
  return <FeatureRadioTileGroup onChange={setCategoryId} value={categoryId} data-sentry-element="FeatureRadioTileGroup" data-sentry-component="TemplateListMobile" data-sentry-source-file="template-list-mobile.tsx">
            {categories.map(category => <FeatureRadioTile key={category.id} title={category.name} value={category.id} variant="seaSalt" scene={<ul className={css.mobileTemplates}>
                            {category.templates.slice(0, 2).map(template => <li key={`${category.id}-${template.id}`}>
                                    <Card className={css.templateIconCard}>
                                        <Box className={css.imageContainer} style={{
            backgroundColor: template.background_color
          }}>
                                            <Image src={template.thumbnail_image} width={83} height={82} alt="" />
                                        </Box>
                                        <HyperLink href={`/templates/${template.id}`} size="minor-xl" className="mi-24">
                                            {template.name}
                                        </HyperLink>
                                    </Card>
                                </li>)}
                        </ul>} />)}
        </FeatureRadioTileGroup>;
}